import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';

import { articleType } from 'common/constants/content';
import { QUERY_ALL_ARTICLES } from './gql';

import Card from './components/card';
import ArticleListModal from './components/article-list';

export default function Article() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [properties, setProperties] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [payment, setPayment] = useState([]);

  const [queryArticles, { data: articlesData, refetch }] = useLazyQuery(QUERY_ALL_ARTICLES, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    queryArticles();
  }, []);

  const handleArticlesData = () => {
    const { booking, payment, property } = articlesData.articles;
    setProperties(property);
    setBookings(booking);
    setPayment(payment);
  };

  useEffect(() => {
    if (articlesData) {
      handleArticlesData();
    }
  }, [articlesData]);

  return (
    <div className="article-wrapper">
      <div className="title-row">
        <span className="title">{t('cms.content.article.title.article')}</span>
        <Button onClick={() => setIsVisible(true)} icon="setting">
          {t('cms.content.article.title.setting')}
        </Button>
      </div>
      <Card
        title={t('cms.content.article.title.properties')}
        type={articleType.PROPERTY}
        data={properties}
        refetch={refetch}
      />
      <Card
        title={t('cms.content.article.title.bookings')}
        type={articleType.BOOKING}
        data={bookings}
        refetch={refetch}
      />
      <Card
        title={t('cms.content.article.title.payment')}
        type={articleType.PAYMENT}
        data={payment}
        refetch={refetch}
      />
      <If condition={isVisible}>
        <ArticleListModal
          visible={isVisible}
          onClose={() => setIsVisible(false)}
          refetch={refetch}
          properties={properties}
          bookings={bookings}
          payment={payment}
        />
      </If>
    </div>
  );
}
